<section class="confirm-dialog">
  <header class="dialog-header">
    <div class="dialog-header__content">
      <h2>{{ data.title }}</h2>

      @if (data.subtitle) {
        <p>{{ data.subtitle }}</p>
      }
    </div>

    <button type="button" class="close-btn" aria-label="Close dialog" (click)="onCancel()">
      <span class="material-symbols-outlined">close</span>
    </button>
  </header>

  <div class="dialog-content">
    @if (data.isAgent) {
      <div class="profile-card">
        <div class="profile-avatar">
          @if (data.agent?.profile_image) {
            <img [src]="data.agent.profile_image" [alt]="data.agent?.name || 'Agent'" />
          } @else {
            {{ getInitials(data.agent) }}
          }
        </div>

        <div class="profile-details">
          <span>Agent</span>

          <strong>
            {{ data.agent?.name }}
          </strong>
        </div>
      </div>
    }

    @if (data.isCustomer) {
      <div class="profile-card">
        <div class="profile-avatar">
          @if (data.customer?.profile_image) {
            <img [src]="data.customer.profile_image" [alt]="data.customer?.name || 'Customer'" />
          } @else {
            {{ getInitialsCustomer(data.customer) }}
          }
        </div>

        <div class="profile-details">
          <span>Customer</span>

          <strong>
            {{ data.customer?.name }}
          </strong>
        </div>
      </div>
    }

    <div class="confirmation-message" [class.confirmation-message--danger]="data.isDanger">
      @if (data.icon) {
        <span
          class="confirmation-icon material-symbols-outlined"
          [class.confirmation-icon--danger]="data.isDanger"
        >
          {{ data.icon }}
        </span>
      }

      <div class="confirmation-copy">
        <p>{{ data.message }}</p>

        @if (data.detail) {
          <p>{{ data.detail }}</p>
        }
      </div>
    </div>
  </div>

  <footer class="dialog-footer">
    <button type="button" class="dialog-btn dialog-btn--secondary" (click)="onCancel()">
      {{ data.cancelBtnText || 'Cancel' }}
    </button>

    <button
      type="button"
      class="dialog-btn"
      [class.dialog-btn--primary]="!data.isDanger"
      [class.dialog-btn--danger]="data.isDanger"
      (click)="onConfirm()"
    >
      {{ data.confirmBtnText || 'Confirm' }}
    </button>
  </footer>
</section>

<!-- <div class="confirm-dialog">
  <div class="confirm-dialog-content">

    <!-- Agent Profile Section --
    @if (data.isAgent) {
      <div class="flex items-center gap-3 mb-4 px-4 py-3 confirm-dialog-profile-bg rounded-t-[16px]">
        <div
          class="w-12 h-12 confirm-dialog-avatar-bg rounded-full flex-shrink-0 overflow-hidden flex items-center justify-center text-lg font-semibold confirm-dialog-avatar-text border confirm-dialog-avatar-border">

          @if (data.agent?.profile_image) {
            <img [src]="data.agent.profile_image" alt="" class="w-full h-full object-cover" />
          } @else {
            {{ getInitials(data.agent) }}
          }

        </div>

        <div class="font-medium text-lg">
          {{ data.agent?.name }}
        </div>
      </div>
    }

    <!-- Customer Profile Section --
    @if (data.isCustomer) {
      <div class="flex items-center gap-3 mb-4 px-4 py-3 confirm-dialog-profile-bg rounded-t-[16px]">
        <div
          class="w-12 h-12 confirm-dialog-avatar-bg rounded-full flex-shrink-0 overflow-hidden flex items-center justify-center text-lg font-semibold confirm-dialog-avatar-text border confirm-dialog-avatar-border">

          @if (data.customer?.profile_image) {
            <img [src]="data.customer.profile_image" alt="" class="w-full h-full object-cover" />
          } @else {
            {{ getInitialsCustomer(data.customer) }}
          }

        </div>

        <div class="font-medium text-lg">
          {{ data.customer?.name }}
        </div>
      </div>
    }

    <h2 mat-dialog-title class="font-bold">
      {{ data.title }}
    </h2>

    <mat-dialog-content>
      {{ data.message }}
    </mat-dialog-content>

    <mat-dialog-actions align="center">
      <div class="flex justify-center w-full gap-3">

        <button
          class="theme-btn-outline"
          (click)="onCancel()">
          {{ data.cancelBtnText || 'Cancel' }}
        </button>

        <button
          class="theme-btn"
          (click)="onConfirm()">
          {{ data.confirmBtnText || 'Confirm' }}
        </button>

      </div>
    </mat-dialog-actions>

  </div>
</div> -->
